import React from 'react'
import PropTypes from 'prop-types'
import { Columns, Icon } from 'src/components'
import { getColor } from 'src/styles'
import { mergeProps } from 'src/util'
import styles from './BlockHeader.scss'

/**
 * The block header component.
 */
const BlockHeader = ({ title, icon, color, toolbar, ...domProps }) => (
  <Columns {...mergeProps()({ className: styles.header }, domProps)} layout="1 auto" align="center">
    <Columns className={styles.title} layout="auto 1" align="center">
      {icon && <Icon icon={icon} fixedWidth />}
      {title && (
        <div className={styles.label} style={{ color: getColor(color) }}>
          {title}
        </div>
      )}
    </Columns>
    {toolbar}
  </Columns>
)

BlockHeader.defaultProps = {
  color: 'dark',
}

BlockHeader.propTypes = {
  /**
   * The title displayed in the block header.
   */
  title: PropTypes.node,
  /**
   * The icon displayed in the block header.
   */
  icon: PropTypes.elementType,
  /**
   * A toolbar node in the block header.
   */
  toolbar: PropTypes.node,
  /**
   * The title color.
   */
  color: PropTypes.string,
}

export default BlockHeader
